import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/admin/internal-tools/')({
  component: () => <Navigate to="/admin/internal-tools/category-audit" replace />,
});
